import { useEffect, useState } from 'react';
import { updateHeader } from 'common/services/common.service';
import { Grid } from 'common/components/grid/Grid';
import { useDispatch, useSelector } from 'react-redux';
import { removeAllRows, setFields, setInitialPath } from 'features/GridSlice';
import { RestApi } from 'common/services/rest-api.service';
import { IRootColumnPicker } from 'common/interfaces/interface';
import { ColumnsManage } from 'common/components/grid/columnsManage';
import { setColumnPicker, setShowColumnPicker } from 'features/columnPickerSlice';

const PAGE_NAME = 'Accounts';

const Accounts = (props: any) => {
  const [data, setData] = useState<any>(initData());
  const dispatch = useDispatch<any>();
  const { isLoggedIn } = useSelector((state: any) => state.login);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      updateHeader.sendHeaderText(PAGE_NAME);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  function initData(): any {
    return {
      rows: [],
      // columnPicker: [],
      // showColumnPicker: false,
      isMoreButton: true,
      isCSVDownloadable: false,
      count: 0,
      columns: [],
      selectTab: '',
      rootPath: '',
      identifier: ''
    };
  }

  const getData = () => {
    setData(initData());
    dispatch(removeAllRows());

    RestApi.getData('mssp/sub-account/columns/').subscribe((columns: IRootColumnPicker) => {
      console.log(columns);
      let fields = ColumnsManage.checkGridColumnsToDisplay(columns.data);
      dispatch(setFields(fields));
      dispatch(setInitialPath('mssp/sub-account/'));

      // IN CASE CUSTOM_GROUPS, ADDING FILTER type__in=1 (the API returns groups + subsidiaries, \
      // need to get only the groups without subsidiaries)

      dispatch(setColumnPicker(columns.data));
      dispatch(setShowColumnPicker(columns.is_displayable));

      setData({
        rows: [],
        // columnPicker: columns.data || [],
        // showColumnPicker: columns.is_displayable,
        isMoreButton: false,
        isCSVDownloadable: columns.is_csv_downloadable,
        count: 0,
        selectTab: '',
        identifier: columns.identifier_field,
        columns: ColumnsManage.createColumns(columns.identifier_field, columns.data || [], {
          page: 'mssp',
          category: '',
          tab: ''
        }),
        rootPath: 'mssp/sub-account/'
      });
    });
  };

  return (
    <div className="sub-layout-pages">
      <div style={{ height: '100%', zIndex: 1 }}>
        {!!data.columns.length && (
          <Grid
            elementSelect={undefined}
            columns={data.columns}
            rows={data.rows}
            count={data.count}
            path={data.rootPath}
            // columnPicker={inventoryData.columnPicker}
            // showColumnPicker={inventoryData.showColumnPicker}
            isMoreButton={data.isMoreButton}
            isCSVDownloadable={data.isCSVDownloadable}
            identifier={data.identifier}
          />
        )}
      </div>
    </div>
  );
};

export default Accounts;
